import { api } from './api'
import type { Config } from '@/types/config'

export const configApi = {
  getConfig: async (): Promise<Config> => {
    console.log('🔍 Fetching config')
    const response = await api.get<Config>('/config')
    console.log('✅ Fetched config:', response.data)
    return response.data
  },

  updateConfig: async (data: Partial<Config>): Promise<Config> => {
    console.log('✏️ Updating config:', data)
    const response = await api.put<Config>('/config', data)
    console.log('✅ Updated config:', response.data)
    return response.data
  }
}